import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { SettingIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createInsurance } from '../../../api/insurances/create-insurance'
import UserNavBar from '../../../components/elements/nav-bar'
import { InsuranceForm } from '../../../components/pages/insurance/insurance-form'
import { Paths } from '../../../lib/constants/path'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'

export function InsuranceCreatePage() {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createInsurance,
    onError: showAxiosError,
    onSuccess: () => toast.success('Assurance créée avec succès')
  })

  return (
    <div>
      <UserNavBar title={'Créer une assurance'} icon={SettingIcon} />
      <div className={'h-4'} />

      <div className="space-y-4">
        <Box>
          <InsuranceForm
            buttonsConfig={twoButtonsConfig({
              onConfirm: async (values) => {
                const res = await mutateAsync(values)
                navigate(Paths.INSURANCE_UPDATE_PAGE.replace(':id', res.id.toString()), {
                  replace: true
                })
              },
              onCancel: () => back(Paths.INSURANCE_LIST_PAGE)
            })}
          />
        </Box>
      </div>
    </div>
  )
}
